<template>
  <perfect-scrollbar>
    <CollapsibleList :items="integrations"
                     v-model="openIntegrations"
                     :selected-index="selectedIntegrationIndex"
                     :is-selected="selectedIntegrationIndex >= 0 && !selectedChannel"
    >
      <template #title="{item}">
        <SettingsIntegrationsListTitle :integration="item"
                                       :bot-name-map="botNameMap"
                                       :is-selected="isIntegrationSelected(item)"
                                       @select-integration="handleIntegrationSelect"
                                       @request-delete="$emit('request-delete', $event)"
        />
      </template>

      <template #content="{item}">
        <SettingsBotsListChannel v-for="(channel, i) in item.channels"
                                 :key="channel.id"
                                 :channel="channel"
                                 :selected-channel="selectedChannel"
                                 :is-last="i === item.channels.length - 1"
                                 @select-channel="selectChannel(channel, i)"
        />
      </template>
    </CollapsibleList>
  </perfect-scrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import CollapsibleList from '@/components/common/CollapsibleList.vue'
import SettingsIntegrationsListTitle from '@/components/settings/integrations/SettingsIntegrationsListTitle.vue'
import SettingsBotsListChannel from '@/components/settings/bots/SettingsBotsListChannel.vue'
import { ROUTE_NAMES } from '@/router'

export default {
  name: 'SettingsIntegrationsList',

  components: {
    PerfectScrollbar,
    CollapsibleList,
    SettingsIntegrationsListTitle,
    SettingsBotsListChannel
  },

  props: {
    selectedIntegrationIndex: {
      type: Number,
      default: -1
    },
    integrations: {
      type: Array,
      required: true
    },
    botNameMap: {
      type: Object,
      default: () => ({})
    },
    selectedChannel: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      openIntegrations: {}
    }
  },

  emits: ['select-integration-index', 'select-channel-index', 'request-delete'],

  watch: {
    selectedIntegrationIndex: {
      immediate: true,
      handler(newIndex) {
        if (newIndex >= 0) {
          this.$set(this.openIntegrations, newIndex, true)
        }
      }
    }
  },

  methods: {
    isIntegrationSelected(item) {
      return this.selectedIntegrationIndex >= 0 &&
             this.integrations[this.selectedIntegrationIndex] &&
             item.id === this.integrations[this.selectedIntegrationIndex].id
    },

    selectChannel(channel, channelIndex) {
      if (channel.id === this.selectedChannel?.id) return

      this.$emit('select-channel-index', channelIndex)
      const selectedIntegrationIndex = this.integrations.findIndex(integration => integration.channels?.find(c => c.id === channel.id))
      const selectedIntegration = this.integrations[selectedIntegrationIndex]
      this.openIntegrations[selectedIntegrationIndex] = true
      this.$emit('select-integration-index', selectedIntegrationIndex)
      this.$router.push({
        name: ROUTE_NAMES.integrationsWithChannel,
        params: {
          integrationId: selectedIntegration.id,
          channelId: channel.id
        }
      })
    },

    handleIntegrationSelect(integration) {
      const selectedIntegrationIndex = this.integrations.findIndex(i => i.id === integration.id)
      this.$emit('select-integration-index', selectedIntegrationIndex)
      this.openIntegrations[selectedIntegrationIndex] = true
      this.$router.push({
        name: ROUTE_NAMES.integrations,
        params: {
          integrationId: integration.id
        }
      })
    }
  }
}
</script>
